import { BlockMemberModal } from './BlockMemberModal';

export default BlockMemberModal;